<template>
  <a-card class="EditQuestion">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="题干" prop="topic">
        <a-input v-model="form.topic" :maxLength="100" placeholder="不超过100个字" type="textarea" />
      </a-form-model-item>
      <a-form-model-item label="关联游戏" prop="games">
        <div class="connectGame" style="" @click="pickContent">
          <span v-if="form.games == '全部'">全部</span>
          <span @click.stop="deleteGame(item, index)" v-for="(item, index) in games.list" :key="index">
            {{ item.name || JSON.parse(item).name }}
            <em><a-icon type="close" /></em>
          </span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="投放率" prop="launchRate">
        <a-input-number :min="0" :max="100" :precision="2" maxLength="5" style="width: 30%" placeholder="精确到小数点后两位" v-model="form.launchRate" />
        <em style="font-style: normal; position: relative; left: -40px">%</em>
      </a-form-model-item>
    </a-form-model>
    <footer-tool-bar>
      <div class="btns">
        <a-button @click="backpage()" style="margin-right: 15px">返回</a-button>
        <a-button type="primary" @click="onSubmit"> 保存 </a-button>
      </div>
    </footer-tool-bar>
    <a-modal v-model="games.visible" title="选择游戏" @ok="handleOk" @cancel="handleCancel" width="1200px">
      <div @keyup.enter="getContentList(1)">
        <a-form layout="inline" class="searchForm search-form">
          <a-form-item label="游戏名称">
            <a-input allowClear placeholder="请输入游戏名称" v-model.trim="games.search.name" />
          </a-form-item>
          <a-form-item label="版本名称">
            <a-input allowClear placeholder="请输入版本名称" v-model.trim="games.search.versionName" />
          </a-form-item>
          <a-form-item label="能力维度">
            <a-cascader style="min-width: 250px" v-model="games.search.abilityList" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getContentList(1)">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-tabs @change="callback" :activeKey="games.activeTab">
        <a-tab-pane key="1" tab="添加测评游戏">
          <a-table
            style="margin-top: 15px"
            :columns="games.columns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :loading="games.tableRelevant.tableLoading"
            :pagination="games.tableRelevant.tablePagination"
            :dataSource="games.tableRelevant.tableDataSource"
          >
            <div slot="classifyTag" slot-scope="text, record">
              {{ text.classifyTag == 1 ? '商用' : text.classifyTag == 4 ? '科研' : '--' }}
            </div>
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
            <div slot="normNum" slot-scope="text, record">
              <div class="self_td" v-for="item in record.contentAbility" :key="item.id">{{ item.normCount }}</div>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              {{ EstimatedTime(record.estimatedTime) }}
            </div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="添加训练游戏">
          <a-table
            style="margin-top: 15px"
            :columns="games.columns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :loading="games.tableRelevant.tableLoading"
            :pagination="games.tableRelevant.tablePagination"
            :dataSource="games.tableRelevant.tableDataSource"
          >
            <div slot="classifyTag" slot-scope="text, record">
              {{ text.classifyTag == 1 ? '商用' : text.classifyTag == 4 ? '科研' : '--' }}
            </div>
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
            <div slot="normNum" slot-scope="text, record">
              <div class="self_td" v-for="item in record.contentAbility" :key="item.id">{{ item.normCount }}</div>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              {{ EstimatedTime(record.estimatedTime) }}
            </div>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import FooterToolBar from '@/components/tool/FooterToolBar'
import { EstimatedTime } from '@/utils/EstimatedTime'

export default {
  name: 'EditQuestion',
  components: { FooterToolBar },
  data() {
    return {
      EstimatedTime,
      record: JSON.parse(localStorage.getItem('commentRecord')),
      labelCol: { span: 2 },
      wrapperCol: { span: 14 },
      form: {
        topic: undefined,
        games: '全部',
        launchRate: undefined,
      },
      rules: {
        topic: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        games: [{ required: true, message: '请选择关联游戏', trigger: 'blur' }],
        launchRate: [{ required: true, message: '请输入投放率', trigger: 'blur' }],
      },
      games: {
        visible: false,
        activeTab: '1',
        search: {
          name: undefined,
          versionName: undefined,
          abilityList: [],
          contentType: 1,
          status: true,
          abilityTypeId: undefined,
          firstAbilityId: undefined,
          secondAbilityId: undefined,
        },
        columns: [
          { title: '名称', dataIndex: 'name', align: 'center' },
          { title: '版本名称', dataIndex: 'versionName', align: 'center' },
          { title: '游戏类型', scopedSlots: { customRender: 'classifyTag' } },
          { title: '能力维度', width: 250, class: 'testClass', key: 'abilityTypeName', align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
          { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
          { title: '年龄范围', scopedSlots: { customRender: 'ages' }, align: 'center' },
        ],
        tableRelevant: tableRelevant.call(this, this.getContentList),
        selectedRowKeys: [],
        list: [],
      },
      options: [],
      selectId: '',
      Id: '', //新增后ID
    }
  },
  watch: {
    'games.list'(val) {
      console.log(val)
      this.form.games = val.length ? val : '全部'
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.games.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.games.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  mounted() {
    this.setTitle()
    this.getContentList(1)
    this.abilityTypeSelect(0)
    if (this.$route.query.id) {
      this.getDetail()
    }
  },
  methods: {
    backpage() {
      this.$router.push('/content/GamesComment?activekey=2')
    },
    // 能力维度选择
    onChange(value) {
      this.games.search.abilityTypeId = value[0]
      this.games.search.firstAbilityId = value[1]
      this.games.search.secondAbilityId = value[2]
      this.selectId = value
    },
    // 能力维度数据加载
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      targetOption.children = []
      let params = {
        pid: this.selectId[this.selectId.length - 1],
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
          targetOption.loading = false
          res.data.data.forEach((item) => {
            let str = {}
            if (this.selectId.length < 2) {
              str = {
                value: item.id,
                label: item.name,
                isLeaf: false,
              }
            } else {
              str = {
                value: item.id,
                label: item.name,
              }
            }
            targetOption.children.push(JSON.parse(JSON.stringify(str)))
            this.options = [...this.options]
          })
      })
    },
    // 能力维度数据加载
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
          this.options = res.data.data
          this.options.forEach((item) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
      })
    },
    setTitle() {
      let tit = this.$route.query.id ? '编辑' : '添加'
      const arr = ['首页', '内容中心', { name: '游戏评价', path: '/content/GamesComment' }, { name: '题目管理', path: '/content/GamesComment?activekey=2' }, tit]
      $Bus.$emit('pageHeaderBreadcrumb', arr)
      $Bus.$emit('pageHeaderTitle', tit)
      $Bus.$emit('updateTabName', { path: this.$route.path, name: '编辑题目' })
    },
    callback(e) {
      if (e == 1) {
        this.games.columns = [
          { title: '名称', dataIndex: 'name', align: 'center' },
          { title: '版本名称', dataIndex: 'versionName', align: 'center' },
          { title: '游戏类型', scopedSlots: { customRender: 'classifyTag' } },
          { title: '能力类型', scopedSlots: { customRender: 'contentType' }, class: 'testClass', align: 'center' },
          { title: '一级能力', scopedSlots: { customRender: 'firstAbilityName' }, class: 'testClass', align: 'center' },
          { title: '二级能力', scopedSlots: { customRender: 'secondAbilityName' }, class: 'testClass', align: 'center' },
          { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
          { title: '年龄范围', scopedSlots: { customRender: 'ages' }, align: 'center' },
        ]
      } else if (e == 2) {
        this.games.columns = [
          { title: '名称', dataIndex: 'name', align: 'center' },
          { title: '版本名称', dataIndex: 'versionName', align: 'center' },
          { title: '能力类型', scopedSlots: { customRender: 'contentType' }, class: 'testClass', align: 'center' },
          { title: '一级能力', scopedSlots: { customRender: 'firstAbilityName' }, class: 'testClass', align: 'center' },
          { title: '二级能力', scopedSlots: { customRender: 'secondAbilityName' }, class: 'testClass', align: 'center' },
          { title: '预计用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
          { title: '年龄范围', scopedSlots: { customRender: 'ages' }, align: 'center' },
        ]
      }
      this.games.activeTab = e
      this.games.search.contentType = e
      this.getContentList(1)
    },
    // 获取选择内容表格数据
    getContentList(pageIndex) {
      this.games.tableRelevant.tableLoading = true
      let params = {
        pageIndex: pageIndex || this.games.tableRelevant.tablePagination.current,
        pageSize: this.games.tableRelevant.tablePagination.pageSize,
        ...this.games.search,
      }
      params.contentType = this.games.activeTab
      this.$http
        .contentPagelist(params)
        .then((res) => {
          this.games.tableRelevant.tableLoading = false
          const { status, data, message } = res.data
          this.games.tableRelevant.tableDataSource = []
          this.$nextTick(() => {
            this.games.tableRelevant.tableDataSource = data.items
            this.games.tableRelevant.tablePagination.total = data.totalCount
            this.games.tableRelevant.tablePagination.current = data.pageIndex

            // 关联游戏回显
            this.games.list.forEach((v) => {
              this.games.tableRelevant.tableDataSource.forEach((m) => {
                if (v.id == m.id) {
                  this.games.selectedRowKeys.push(JSON.stringify(m))
                }
              })
            })
          })
        })
        .catch((err) => {
          this.games.tableRelevant.tableLoading = false
        })
    },
    pickContent() {
      this.games.visible = true
      this.getContentList(1)
    },
    // 删除选中
    deleteGame(item, index) {
      this.games.list.splice(index, 1)
      this.games.selectedRowKeys = this.games.list.map((v) => {
        return JSON.stringify(v)
      })
    },
    handleOk() {
      this.games.list = this.games.selectedRowKeys
      this.handleCancel()
    },
    handleCancel() {
      this.games.visible = false
      this.games.activeTab = '1'
      this.games.search = {
        name: undefined,
        versionName: undefined,
        abilityList: [],
        contentType: 1,
        status: true,
        abilityTypeId: undefined,
        firstAbilityId: undefined,
        secondAbilityId: undefined,
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let arr = []
          if (this.form.games == '全部') {
            arr = []
          } else {
            this.form.games.forEach((v) => {
              if (v.id) {
                arr.push(v.id)
              } else {
                arr.push(JSON.parse(v).id)
              }
            })
          }
          let params = {
            topic: this.form.topic,
            launchRate: this.form.launchRate,
            rule: arr,
          }
          if (this.$route.query.id || this.Id) {
            params.id = this.$route.query.id || this.Id
            this.edit(params)
          } else {
            this.add(params)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    edit(params) {
      this.$http.GamesComment.editTopic(params).then((res) => {
        const { status, data, message } = res
        this.$message.success(message)
      })
    },
    add(params) {
      this.$http.GamesComment.addTopic(params).then((res) => {
        const { status, data, message } = res
        this.$message.success(message)
        this.Id = data
      })
    },
    // 获取详情
    getDetail() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.GamesComment.topicDetail(params).then((res) => {
        const { status, data, message } = res
        this.form = {
          topic: data.topic,
          games: undefined,
          launchRate: data.launchRate,
        }
        if (!data.rule.length) {
          this.form.games = '全部'
        } else {
          this.games.list = data.contentInfo
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
.connectGame {
  cursor: text;
  min-height: 52px;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 4px;
  // padding: 0 15px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0 5px 0;
  span {
    padding: 5px 10px;
    border: 1px solid rgb(217, 217, 217);
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    height: 30px;
    line-height: 20px;
    margin-left: 15px;
    margin-bottom: 5px;

    em {
      font-style: normal;
      margin-left: 10px;
    }
  }
}
.connectGame:hover {
  border-color: #13c2c2;
}
/deep/ .ant-input-number-input {
  padding-right: 100px;
}
</style>
